/**
 * @generated SignedSource<<7b9b8bf073c235e90a96a50467d7ac74>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type User_user$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type MembersChooser_team$fragmentType: FragmentType;
export type MembersChooser_team$data = {|
  +id: string,
  +organization: ?{|
    +members: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +user: {|
            +id: string,
            +$fragmentSpreads: User_user$fragmentType,
          |},
        |},
      |}>,
    |},
  |},
  +permissions: {|
    +teamMemberCreate: ?{|
      +allowed: boolean,
    |},
  |},
  +slug: string,
  +$fragmentType: MembersChooser_team$fragmentType,
|};
export type MembersChooser_team$key = {
  +$data?: MembersChooser_team$data,
  +$fragmentSpreads: MembersChooser_team$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "memberAddSearch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamSelector"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembersChooser_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            },
            {
              "kind": "Literal",
              "name": "order",
              "value": "RELEVANCE"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "memberAddSearch"
            },
            {
              "kind": "Variable",
              "name": "team",
              "variableName": "teamSelector"
            }
          ],
          "concreteType": "OrganizationMemberConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMemberEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrganizationMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "User_user"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamMemberCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "589d7514cfc77b769f8347e44d2c5358";

module.exports = ((node/*: any*/)/*: Fragment<
  MembersChooser_team$fragmentType,
  MembersChooser_team$data,
>*/);
